import { render, staticRenderFns } from "./departmentsList.vue?vue&type=template&id=0d72b07e"
import script from "./departmentsList.vue?vue&type=script&lang=js"
export * from "./departmentsList.vue?vue&type=script&lang=js"
import style0 from "./departmentsList.vue?vue&type=style&index=0&id=0d72b07e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports